import Api from '@/services/api';

const state = () => ({
  token: null,
  member: null,
  wishlists: {
    result: [],
    pagination: null,
  },
  comparison: {
    result: [],
    pagination: null,
  },
  rates: {
    result: [],
    pagination: null,
  },
});

const mutations = {
  SET_USER(state, payload) {
    const { member, token } = payload;
    state.token = token;
    state.member = member;
  },

  REMOVE_USER(state) {
    state.token = null;
    state.member = null;
  },

  SET_WISHLISTS(state, payload) {
    state.wishlists = payload;
  },

  SET_COMPARISON(state, payload) {
    state.comparison = payload;
  },

  SET_RATES(state, payload) {
    state.rates = payload;
  },
};

const actions = {
  logout({ commit }) {
    commit('REMOVE_USER');
  },

  async getWishlists({ commit, state }, payload) {
    if (!state.token) return;

    const params = {
      username: state.member.email,
      page: payload || 1,
      show: 100,
    };

    const res = await Api().get('wishlist-products', { params })
      .then((res) => res.data.data.result);

    const payloadData = {
      result: res.data,
      pagination: {
        current: res.current_page,
        last: res.last_page,
        total: res.total,
      },
    };

    commit('SET_WISHLISTS', payloadData);
  },

  async getComparison({ commit, state }, payload) {
    if (!state.token) return;

    const params = {
      username: state.member.email,
      page: payload || 1,
      show: 100,
    };

    const res = await Api().get('compares', { params })
      .then((res) => res.data.data.result);

    const payloadData = {
      result: res.data,
      pagination: {
        current: res.current_page,
        last: res.last_page,
        total: res.total,
      },
    };

    commit('SET_COMPARISON', payloadData);
  },

  async getRates({ commit, state }, payload) {
    if (!state.token) return;

    const params = {
      username: state.member.email,
      page: (payload) || 1,
      show: 100,
    };

    const res = await Api().get('rate-products', { params })
      .then((res) => res.data.data.result);

    const payloadData = {
      result: res.data,
      pagination: {
        current: res.current_page,
        last: res.last_page,
        total: res.total,
      },
    };

    commit('SET_RATES', payloadData);
  },
};

const getters = {
  isAuthenticated(state) {
    return (!state.token);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
